"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PendoRebranding = function PendoRebranding(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "#2C3941",
    rx: 20.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F2A30",
    d: "M9.151 30.383 26.55 51.982 54.91 32.235 30.36 8.785 9.15 30.383Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.786 11.714a2.929 2.929 0 0 1 2.929-2.929h17.571a2.929 2.929 0 0 1 2.929 2.929V34.41l-7.113-2.48H11.715a2.929 2.929 0 0 1-2.929-2.928V11.714Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M18.211 22.092h-4.513a.698.698 0 0 0-.697.697v4.513c0 .386.312.698.697.698h4.513a.697.697 0 0 0 .698-.698V22.79a.697.697 0 0 0-.698-.697Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M15.262 13.697v4.514c0 .385.312.697.697.697h5.435c.386 0 .698.312.698.697v5.319c0 .385.312.698.697.698h4.513a.697.697 0 0 0 .698-.698V13.697a.697.697 0 0 0-.698-.697H15.96a.697.697 0 0 0-.697.697Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 13.51,
    x2: 18.368,
    y1: 27.49,
    y2: 22.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA23C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FD5782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 18.472,
    x2: 27.691,
    y1: 22.469,
    y2: 13.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#812DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E3AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2572EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0989E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "#fff",
    rx: 20.5
  }))));
};
var _default = exports["default"] = PendoRebranding;